import { createI18n } from '@/i18n'
import router from './js/routers'
import store from './js/store'

export function createApp({ Vue, I18n }) {
  const i18n = createI18n({ Vue, I18n })
  Vue.prototype.$body = document.body
  const app = new Vue({
    i18n,
    router,
    store,
    delimiters: ['[[', ']]'],
    data() {
      return {
        True: true,
        False: false,
        None: undefined,
      }
    },
  })

  return { store, app, router, i18n }
}
